/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useForm from "../../hooks/useForm";

import { toggleNotice } from "../../store/actions";
import Form from "../Form";
import Modal, { ModalHeader } from "../Modal";
import { boardShare, createNotice, deleteNotice, modifyNotice } from "../../apis/boards";
import { NOTICE_SHARE, NOTICE_TOP_EXPOSURE } from "../../constants/NOTICE";
import { isObject } from "lodash-es";
import systemAlert from "../../utils/systemAlert";
import { viewLoading } from "../../utils/loading";
import Profile from "../Profile";
import { dateToFormat, dateToViewFormatWithDayNameWithTime, formatDateHour } from "../../utils/date";
import NoticeIcon from "../../assets/images/icon/notice-icon.svg";
import Icon from "../Icon";
import { isEmpty } from "lodash";
import Button from "../Button";
import CareCompaniesModal from "../CareCompany/CareCompaniesModal";
import { getAllCareCompanies } from "../../apis/admin/companies";
// import { isManagerCompany } from "../../utils/auth";

const NoticeDetail = () => {
  const modalEl = useRef(null);
  const [minHeight, setMinHeight] = useState(0);
  const [mode, setMode] = useState("create");
  const [buttons, setButtons] = useState([]);
  const [targetPermission, setTargetPermission] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const { noticeData, employees, permissions, employee, user } = useSelector((store) => ({
    noticeData: store.Notice.noticeData,
    employees: store.Data.employees,
    permissions: store.Profile.permissions,
    employee: store.Profile.employee,
    user: store.Profile.user,
  }));

  const [careCompanies, setCareCompanies] = useState([]);

  const [selectedCareCompany, setSelectedCareCompany] = useState([]);

  const [isManager, setIsManager] = useState(false);


  useEffect(() => {
    if (employee && employee.type > 1) {
      getAllCareCompanies(employee.managerCompanyIdx, employee.type)
        .then(res => {
          setCareCompanies(res.data?.companies || []);
        });
    }
  }, [employee]);

  const reset = () => {
    dispatch(toggleNotice(false));
    setMode("create");
    setMinHeight(0);
    resetForm();
    setSelectedCareCompany([]);
  };

  const close = (e) => {
    if (e) {
      e.preventDefault();
    }
    reset();
  };

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === "NOTICE");
      setTargetPermission(permission);
    }
  }, [permissions]);

  useEffect(() => {
    if (noticeData) {
      if (window?.location?.pathname) {
        const isManager =
          window.location.pathname === "/managing/notice-board" ||
          window.location.pathname === "/tax-portal/notices" ||
          (user.type > 1 && !!(noticeData.boardToCompanies || []).find(f => f.writeComIdx === user.managerCompanyIdx));
        setIsManager(isManager);
      }
    }

    if (noticeData && isObject(noticeData) && noticeData.isManager && isManager) {
      setSelectedCareCompany(careCompanies.filter(f =>
        (noticeData.boardToCompanies || []).find(ff => {
          f.companyIdx === ff.companyIdx && console.log(f.companyIdx);
          return f.companyIdx === ff.companyIdx;
        }
        )
      ));
    }
  }, [isManager, noticeData]);

  useEffect(() => {
    if (noticeData && isObject(noticeData)) {
      resetForm();
      setForm({
        // idx: noticeData.idx,
        ...noticeData,
        topExposure: String(noticeData.topExposure),
        fileIdxes: noticeData.uploadFiles,
        // title: noticeData.title,
        // content: noticeData.content,
        // share: noticeData?.share,
        // shareDateTime: noticeData?.shareDateTime,
        // createdTime: noticeData?.createdTime,
      });
      setMode("detail");
    }
    if (
      noticeData
      && modalEl
      && modalEl.current
    ) {
      setTimeout(() => {
        setMinHeight(modalEl.current.offsetHeight);
      }, 500);
    }
  }, [noticeData, modalEl]);


  const [fields, setFields] = useState([]);

  const validate = ({
    title,
    content
  }) => {
    let errors = {};

    if (!title) errors.title = "제목은 필수입니다.";
    if (!content) errors.content = "내용은 필수입니다.";
    if (isManager && isEmpty(selectedCareCompany)) errors.selectedCareCompany = "회사선택은 필수입니다.";
    return errors;
  };

  const submit = (_form) => {

    if (mode === "create") {
      const body = {
        ..._form,
        isManager,
      };

      if (isManager) {
        body["selectedCompanies"] = selectedCareCompany.map(item => item.companyIdx);
      }

      console.log(body);
      systemAlert("공지사항을 작성하시겠습니까?", {
        buttons: [
          {
            color: "text",
            label: "취소"
          },
          {
            label: "승인",
            onClick: () => {
              viewLoading(true);
              createNotice(body, isManager ? "client_wide_notice" : "notice")
                .then((res) => {
                  window.location.reload();
                })
                .finally(() => {
                  viewLoading(false);
                });
            }
          }
        ]
      });
    } else if (mode === "modify") {

      const body = {
        ..._form,
        isManager,
      };

      if (isManager) {
        body["selectedCompanies"] = selectedCareCompany.map(item => item.companyIdx);
      }
      systemAlert(`"${_form.title}" 수정하시겠습니까?`, {

        buttons: [
          {
            color: "text",
            label: "취소"
          },
          {
            label: "승인",
            onClick: () => {
              modifyNotice(body, isManager ? "client_wide_notice" : "notice")
                .then(() => {
                  window.location.reload();
                });
            }
          }
        ]
      });
    }
  };

  const deleteSubmit = () => {
    systemAlert(`"${form.title}" 삭제하시겠습니까?`, {

      buttons: [
        {
          color: "text",
          label: "취소"
        },
        {
          color: "red",
          label: "삭제",
          onClick: () => {
            deleteNotice(form.idx, isManager ? "client_wide_notice" : "notice")
              .then(() => {
                window.location.reload();
                // close()
                // systemAlert("삭제 되었습니다.", [
                //   {
                //     label: "확인",
                //     onClick: () => {
                //     }
                //   }
                // ])

              });
          }
        }
      ]
    });
  };

  const modifyMode = () => {
    setMode("modify");
  };

  const {
    form,
    errors,
    setForm,
    handleOnChange,
    handleSubmit,
    resetForm,
  } = useForm(
    {
      topExposure: "1",
      title: "",
      content: "",
      fileIdxes: [],
      share: "notice"
    },
    submit,
    validate,
    fields
  );

  const shareBoardPost = () => {

    const body = {
      idx: noticeData.idx
    };

    boardShare(body).then(() => {
      window.location.reload();
    });
  };

  useEffect(() => {
    if (targetPermission) {
      const managerPermissionChecked = noticeData?.isManager ?
        user.type > 1 &&
        (noticeData?.boardToCompanies || []).find(f => f.writeComIdx === user.managerCompanyIdx)
        : true;
      setButtons([
        {
          color: 'green',
          className: 'float-left handover-btn',
          isHide: !isManager ||
            mode !== "detail" ||
            !isEmpty(noticeData?.shareDateTime) ||
            (mode === "detail" && noticeData?.type !== "client_wide_notice"),
          onClick: shareBoardPost,
          label: '개시하기'
        },
        {
          color: "text",
          label: "닫기",
          onClick: close
        },
        {
          isHide: !managerPermissionChecked || mode !== "detail" || targetPermission.level < 2 || !isEmpty(noticeData?.shareDateTime),
          label: "수정하기",
          onClick: modifyMode
        },
        {
          isHide: !managerPermissionChecked || mode !== "modify" || targetPermission.level < 2,
          label: "수정",
          onClick: handleSubmit
        },
        {
          // isHide: (mode !== "create" || targetPermission.level < 2) && !isManager,
          label: "글쓰기",
          onClick: handleSubmit
        },
        {
          isHide: !managerPermissionChecked || mode !== "detail" || targetPermission.level < 2 || !isEmpty(noticeData?.shareDateTime),
          color: "red",
          label: "삭제",
          onClick: deleteSubmit
        },
      ]);
    }
  }, [mode, targetPermission, noticeData, isManager]);

  useEffect(() => {
    setFields([
      {
        type: !isEmpty(noticeData) && isObject(noticeData) ? "text" : "radio",
        key: "share",
        title: "개시대상",
        options: {
          list: NOTICE_SHARE
        },
        isHide: (v) => !isManager || (mode === "detail" && v?.form?.type !== "client_wide_notice"),
        onValue: (v) => NOTICE_SHARE.find(f => f.value === v)?.label || v
      },
      {
        title: "개시날짜",
        isHide: (v) => {
          const { form = {} } = v;
          return mode !== "detail" || !isManager || form.type !== "client_wide_notice";
        },
        key: "shareDateTime",
        onValue: (v) => v ? dateToFormat(v, formatDateHour) : "-"
      },
      {
        title: "공지 노출 회사",
        type: "text",
        onValue: () => {
          return !isEmpty(selectedCareCompany)
            ? selectedCareCompany.map(m => m.name).join(", ")
            : "선택회사 없음";
        },
        key: "selectedCareCompany",
        isHide: () => !isManager
      },
      {
        isHide: () => {
          return mode === "detail" || (isManager && form?.share === "counseling");
        },
        title: "공지",
        key: "topExposure",
        type: "select",
        options: {
          list: NOTICE_TOP_EXPOSURE,
        },
        className: "zIndex-0",
        // required: true,
      },
      {
        title: "제목",
        key: "title",
        type: "input",
        // required: true,
      },
      {
        isHide: mode === "create",
        title: "작성자",
        type: "component",
        component: () => {
          const writer = employees.find(d => d.idx === noticeData.writerEmpIdx);
          return <><Profile data={writer}></Profile></>;
        }
      },
      {
        isHide: mode === "create",
        title: "작성일",
        type: "component",
        component: () => {
          return <>{dateToViewFormatWithDayNameWithTime(noticeData.createdTime)}</>;
        }
      },
      {
        title: "내용",
        key: "content",
        type: "editor",
        // required: true,
      },
      {
        title: "첨부파일",
        key: "fileIdxes",
        type: "dropzone",
        required: false,
      },

      {
        isHide: mode !== "detail",
        type: "reaction",
        params: {
          postIdx: "idx",
          postType: "board"
        },
        fullWidth: true
      },
    ]);
  }, [mode, employee, selectedCareCompany, isManager, form && form?.share, noticeData]);

  return (
    <Modal
      isOpen={!!noticeData}
      toggle={close}
    >
      <div
        className="notice-write"
        ref={modalEl}
        style={{
          minHeight
        }}
      >
        <ModalHeader>
          <Icon src={NoticeIcon} />&nbsp;
          공지사항 {mode === "create" && "작성"}
        </ModalHeader>
        {
          isManager && employee?.type > 1 && mode !== "detail" && (
            <div style={{
              position: "absolute",
              top: "54px",
              right: "48px",
            }}>
              <Button
                action={() => setIsOpen(true)}
                label="회사 선택하기"
              />
            </div>
          )
        }
        <Form
          mode={mode}
          isRequiredShow={true}
          fields={fields}
          form={form}
          onChange={handleOnChange}
          buttons={buttons}
          errors={errors}
        />
      </div>
      {/* {isOpen && ( */}
      <CareCompaniesModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        selectedCareCompany={selectedCareCompany}
        setSelectedCareCompany={setSelectedCareCompany}
      />
      {/* )} */}
    </Modal>
  );
};


export default NoticeDetail;
